import Http from '../http'

export default {

  profile() {
    let base = process.env.VUE_APP_API_BASE || "/"
    // console.log({base});
    return Http({ url: '/auth/profile', baseURL: base })
    // return Http.get(`/wholesale_trucks`)
  },

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/users`, {params: {...filter}})
  },
}